<div class="card mb-5">
	<div class="card-header">
		<h3>Partidas Contables
			<span (click)="modalCreateAccounting = true" class="clickeable text-info">
				<span class="sp-con-default">
					<i class="fa-solid fa-circle-plus"></i>
					<i style="color: var(--bs-bg-servicios);" class="fa-solid fa-file sp-el-default"></i>
				</span>
				<span>
					Nueva Partida
				</span>
			</span>
		</h3>
	</div>
	<div class="card-body">
		<div class="row">
			<div class="col" id="list-container">
				<h5>Filtrar</h5>
				<div class="row" style="margin-top: 1em;" id="options-other-filters">
					<div class="col-sm form-group">
						<label for="filterVendors" class="form-label">Buscar por nombre o tipo</label>
						<div class="input-group">
							<input type="text" id="filterVendors" (input)="searching()" [(ngModel)]="search"
								placeholder="Ingresa nombre o tipo de la partida" name="filterVendors"
								class="form-control">
						</div>
					</div>
					<!-- <div class="col-sm form-group">
						<label for="pageSize" class="form-label">Mostrar</label>
						<select name="pageSize" (change)="validateFields()" id="pageSize" class="form-select"
							[(ngModel)]="pageSize">
							<option value="4">4 Partidas</option>
							<option value="8">8 Partidas</option>
							<option value="20">20 Partidas</option>
							<option value="60">60 Partidas</option>
							<option value="100">100 Partidas</option>
							<option value="200">200 Partidas</option>
							<option value="500">500 Partidas</option>
							<option value="1000">1000 Partidas</option>
						</select>
					</div> -->
					<div class="col-sm form-group">
						<label for="startDate" class="form-label">Fecha Inicial</label>
						<input type="date" name="startDate" (change)="validateFields()" [(ngModel)]="startDate"
							id="startDate" class="form-control">
					</div>
					<div class="col-sm form-group">
						<label for="endDate" class="form-label">Fecha Final</label>
						<input type="date" name="endDate" (change)="validateFields()" [(ngModel)]="endDate" id="endDate"
							class="form-control">
					</div>
				</div>
				<div class="table-responsive" style="margin-bottom: 0;">
					<table class="table table-bordered" style="margin-bottom: 0;">
						<thead>
							<tr>
								<th class="td-center">
									Número
								</th>
								<th class="ta">
									Nombre
								</th>
								<th class="td-center">
									Tipo
								</th>
								<th class="td-center">
									Fecha Ingreso
								</th>
								<th class="td-center">
									Fecha Total
								</th>
							</tr>
						</thead>
						<tbody>
							<ng-container *ngFor="let entry of pagination.filter">
								<tr class="entry" [class.tr-selected]="seeing == entry.id" (click)="showDetail(entry)">
									<td class="td-center">
										#{{entry.number}}
									</td>
									<td class="ta">
										{{entry.description}}
									</td>
									<td class="td-center">
										{{entry.module}}
									</td>
									<td class="td-center">
										{{entry.date | date:'dd/MM/YYYY'}}
									</td>
									<td class="td-center">
										{{entry.total | currency: 'Q'}}
									</td>
								</tr>
								<tr *ngIf="entry.id == seeing">
									<td colspan="5" style="padding: 1rem; background-color: var(--bs-bg-servicios);">
										<table class="table inside-table">
											<thead>
												<tr>
													<th colspan="4" [class.td-center]="!entry.edition">
														<span *ngIf="!entry.edition" class="text-info display-edit"
															(click)="editAccountV2(entry)">
															{{entry.description}}
															<i class="fa fa-edit"></i>
														</span>
														<div class="form-group" *ngIf="entry.edition">
															<div class="input-group">
																<label for="newDescription"
																	class="input-group-text">Descripción
																	<i *ngIf="entry.updateDescription != entry.description"
																		[tooltip]="'Cambios en la descripción'"
																		class="fa fa-circle text-info"></i> </label>
																<input type="text"
																	[class.bg-info-custom]="entry.updateDescription != entry.description"
																	[(ngModel)]="entry.updateDescription"
																	id="newDescription" name="newDescription"
																	class="form-control">
															</div>
															<span style="font-weight: normal;"
																*ngIf="entry.updateDescription != entry.description"
																class="text-muted form-text">
																Actual: <b>{{entry.description}}</b>
															</span>
														</div>
													</th>
												</tr>
												<tr>
													<th class="td-center">Cuenta Contable</th>
													<th class="td-center">Nombre de Cuenta</th>
													<th class="td-center">Debe</th>
													<th class="td-center">Haber</th>
												</tr>
											</thead>
											<tbody>
												<tr *ngFor="let entryData of entry.entries">
													<td [class.td-center]="!entry.edition">
														<span *ngIf="!entry.edition" (click)="editAccountV2(entry)"
															class="text-info display-edit">{{entryData.accountData.displayId}}
															<i class="fa fa-edit"></i>
														</span>
														<span *ngIf="entry.edition">
															<div class="form-group">
																<div class="input-group">
																	<app-input-autocomplete [typeElements]="'accounts'"
																		[filterElements]="inputs[entryData.id].filterElements"
																		[inputs]="inputs[entryData.id]"
																		(inputMethod)="filterAccounts(inputs[entryData.id], entryData)"
																		(changeStatus)="selectAccount($event.filterElement, inputs[entryData.id], entryData)"
																		[allBorderRadius]="true"
																		[placeholder]="'Actual: '+ entryData.accountData.displayId+' '+entryData.accountData.name"
																		(getTitle)="$event.filterElement.title = $event.filterElement.displayId + ' '+ $event.filterElement.name">
																	</app-input-autocomplete>
																</div>
																<span style="text-align: left !important;"
																	*ngIf="entryData.account != entryData.updateAccount"
																	class="form-text text-muted">Actual:
																	<b>{{entryData.accountData.displayId +" " +
																		entryData.accountData.name}}</b></span>
															</div>
														</span>
													</td>
													<td class="td-center">
														{{entryData.accountData.name}}
													</td>
													<td class="td-center">
														{{entryData.debit | currency: 'Q'}}
													</td>
													<td class="td-center">
														{{entryData.credit | currency: 'Q'}}
													</td>
												</tr>
												<tr>
													<td colspan="2" class="td-center"><b>Balance</b></td>
													<td class="td-center">{{getTotal(entry.entries, false) | currency:
														'Q'}}</td>
													<td class="td-center">{{getTotal(entry.entries, true) | currency:
														'Q'}}</td>
												</tr>
												<tr class="edit-mode" *ngIf="entry.edition">
													<td colspan="2" class="align-middle">Estás en modo de edición,
														cualquier campo que tenga <i class="fa fa-circle text-info"></i>
														será modificado, los campos que tengan error <i
															class="fa fa-xmark text-danger"></i> no se modificarán.
													</td>
													<td class="td-center">
														<button class="btn btn-info" (click)="cancelChanges(entry)"><i
																class="fa fa-ban"></i>CANCELAR</button>
													</td>
													<td class="td-center">
														<button class="btn btn-success" [disabled]="updating[entry.id]"
															(click)="saveChanges(entry)">
															<i *ngIf="!updating[entry.id]" class="fa fa-save"></i>
															<span *ngIf="updating[entry.id]"
																class="spinner-border spinner-border-sm"></span>
															GUARDAR CAMBIOS
														</button>
													</td>
												</tr>
											</tbody>
										</table>
									</td>
								</tr>
							</ng-container>
							<tr *ngIf="pagination.filter.length == 0">
								<td colspan="5" class="td-center" style="color: gray">
									<i class="fa fa-circle-info"></i>No se encontraron partidas en las fechas
									seleccionadas
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<app-pagination-custom [pageSizeElements]="[4,8,20,60,100,200,500,1000]" [elements]="pagination"></app-pagination-custom>
			</div>
		</div>
	</div>
</div>
<app-modal-create-accounting-entry *ngIf="modalCreateAccounting"
	(close)="modalCreateAccounting = false"></app-modal-create-accounting-entry>